import React from 'react'

function PhoneMessageIcon(props: any) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        fill: 'currentColor',
        viewBox: '0 0 24 24',
        'aria-hidden': 'true'
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21.5 0.5H11.5C10.9696 0.5 10.4609 0.710714 10.0858 1.08579C9.71071 1.46086 9.5 1.96957 9.5 2.5V12.5C9.5 12.6326 9.55268 12.7598 9.64645 12.8536C9.74021 12.9473 9.86739 13 10 13C10.1043 13.0003 10.206 12.9675 10.2905 12.9065L13.66 10.5H21.5C22.0304 10.5 22.5391 10.2893 22.9142 9.91421C23.2893 9.53914 23.5 9.03043 23.5 8.5V2.5C23.5 1.96957 23.2893 1.46086 22.9142 1.08579C22.5391 0.710714 22.0304 0.5 21.5 0.5ZM16 7.5H13C12.8674 7.5 12.7402 7.44732 12.6464 7.35355C12.5527 7.25978 12.5 7.13261 12.5 7C12.5 6.86739 12.5527 6.74021 12.6464 6.64645C12.7402 6.55268 12.8674 6.5 13 6.5H16C16.1326 6.5 16.2598 6.55268 16.3536 6.64645C16.4473 6.74021 16.5 6.86739 16.5 7C16.5 7.13261 16.4473 7.25978 16.3536 7.35355C16.2598 7.44732 16.1326 7.5 16 7.5ZM20 4.5H13C12.8674 4.5 12.7402 4.44732 12.6464 4.35355C12.5527 4.25978 12.5 4.13261 12.5 4C12.5 3.86739 12.5527 3.74021 12.6464 3.64645C12.7402 3.55268 12.8674 3.5 13 3.5H20C20.1326 3.5 20.2598 3.55268 20.3536 3.64645C20.4473 3.74021 20.5 3.86739 20.5 4C20.5 4.13261 20.4473 4.25978 20.3536 4.35355C20.2598 4.44732 20.1326 4.5 20 4.5Z'
    }),
    React.createElement('path', {
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      fill: props?.color ?? 'currentColor',
      d: 'M15.5 11.5V19.5C15.5 19.6326 15.4473 19.7598 15.3536 19.8536C15.2598 19.9473 15.1326 20 15 20H3.5C3.36739 20 3.24022 19.9473 3.14645 19.8536C3.05268 19.7598 3 19.6326 3 19.5V5.5C3 5.36739 3.05268 5.24021 3.14645 5.14645C3.24022 5.05268 3.36739 5 3.5 5H8.5V2.5H4C3.46957 2.5 2.96086 2.71071 2.58579 3.08579C2.21071 3.46086 2 3.96957 2 4.5V21.5C2 22.0304 2.21071 22.5391 2.58579 22.9142C2.96086 23.2893 3.46957 23.5 4 23.5H14.5C15.0304 23.5 15.5391 23.2893 15.9142 22.9142C16.2893 22.5391 16.5 22.0304 16.5 21.5V11.5H15.5Z'
    })
  )
}

export default PhoneMessageIcon
